import React from "react";
import "../../assets/css/home.css";
import { Box } from "@mui/system";
const Main = (props) => {
  return (
    <Box>
      <props.content
        {...props}
      />
    </Box>
  );
};
export default Main;
